// extracted by mini-css-extract-plugin
export var searchHeader = "_9u-0";
export var searchHeaderDark = "_9u-1";